import { clsx } from 'clsx';
import React, { PropsWithChildren } from 'react';

export const ResponsiveNavigator: React.FC<PropsWithChildren> = React.memo(
  ({ children }) => {
    return (
      <div className="flex flex-1 flex-col">
        <div className="flex flex-1 flex-col md:flex-row pr-safe pt-safe max-w-full">
          <div
            className={clsx(
              'flex flex-1 flex-col pt-4 mt-4 md:pt-8 gap-4 overflow-x-hidden items-center',
              'container mx-auto px-0'
            )}
          >
            {children}
          </div>
        </div>
      </div>
    );
  }
);
